import { Injectable, inject } from '@angular/core';
import { HttpService } from './http.service';
import { UrlService } from './url.service';
import * as i0 from "@angular/core";
export class ApiService {
    constructor() {
        this.urlService = inject(UrlService);
        // private authOktaService = inject(AuthOktaService);
        this.httpService = inject(HttpService);
    }
    getUserContext() {
        return this.httpService.get(this.urlService.userContextUrl);
        // return from(this.authOktaService.isUserAuthenticated()).pipe(
        //   filter((value) => !!value),
        //   switchMap(() =>
        //     this.httpService
        //       .get<UserContext>(this.urlService.userContextUrl)
        //       .pipe(shareReplay())
        //   )
        // );
    }
    getAuxiliaryQualtricsUserData() {
        return this.httpService.get(this.urlService.qualtricsUserData);
    }
    getUserInfo() {
        return this.httpService.get(this.urlService.userInfoUrl);
    }
    download(baseUrl, payloads) {
        const { headers = {}, params = {}, responseType = 'blob' } = payloads ?? {};
        return this.httpService.get(baseUrl, headers, params, responseType);
    }
    static { this.ɵfac = function ApiService_Factory(t) { return new (t || ApiService)(); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ApiService, factory: ApiService.ɵfac, providedIn: 'root' }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ApiService, [{
        type: Injectable,
        args: [{
                providedIn: 'root',
            }]
    }], null, null); })();
